class Customer.ResponseTemplateListView extends Backbone.View
  templateHeader: JST["backbone/templates/customer/ticket/response_template/list"]
  templateRow: JST["backbone/templates/customer/ticket/response_template/row"]

  events:
    'click .btn-add': '_createNew'
    'click .btn-export': '_exportAll'
    'click #delete-text': 'clearSearch'
    'keyup #search-text': 'searchResponses'

  initialize: (@options = {}) ->
    @page = 1
    @per_page = 20
    @collection = Customer.ResponseTemplateCollection.getCollection()
    @context = new Customer.ResponseTemplateContext(@options.context)
    @$el.lazyLoad(success: @render).bindToCollection(@collection)

  render: =>
    @$el.html(@templateHeader({self: @}))
    @tbody = @$el.find('tbody')
    @prepareModels()
    @hideExportIfForUser()
    @renderList()
    @

  renderList: =>
    @tbody.empty()
    @page_list = @paginator_view.paginator.page(@page)
    _.each @page_list, (mod) =>
      row = $(@templateRow({self: @, model: mod}))
      row.find('.action-delete').on('click', mod, @_destroy)
      row.find('.action-edit').on('click', mod, @_edit)
      @tbody.append(row)

  clearSearch: ->
    @$el.find('#search-text').val('')
    @render()

  searchResponses: ->
    event.preventDefault()
    text_to_search = @$el.find('#search-text').val()
    if _.size(text_to_search) >= @collection.minLettersToSearch(@full_collection_size)
      results = @filterTemplates(text_to_search)
      @paginateResults(results)
      @renderList(results)

  filterTemplates: (word) =>
    result = []
    for model in @list
      _templates = model.attributes.templates
      if @hasWord(model.attributes.title, word)
        result.push(model)
      else
        _.some(_templates, (_template) =>
          result.push(model) if @hasWord(_template, word)
        )
    return result

  prepareModels: ->
    if(@context.isAccount())
      @list = @collection.getAccountModels()
    else if(@context.isClient())
      @list = @collection.getClientModels()
    ordered_list =  _.sortBy @list, (mod) ->
      if mod.get('automatic') then mod.get('priority') else 100
    @paginateResults(ordered_list)
    @full_collection_size = _.size(ordered_list)
    ordered_list

  hideExportIfForUser: ->
    if(@context.isClient())
      @$el.find('.btn-export').hide()

  paginateResults: (ordered_list) ->
    @page = 1
    @paginator_view = new Monitoring.Views.PaginatorView(ordered_list, @per_page)
    @listenTo(@paginator_view, 'paginator:page_changed', @pageChanged)
    @$el.find('.paginator_container').html(@paginator_view.render().el)

  pageChanged: (page) ->
    @page = page
    @renderList()
    @$el.find('.template-list').children('tbody').animate({ scrollTop: 0 }, 100);

  _createNew: =>
    new Customer.ResponseTemplateEditorView({new: true, model: new @collection.model(), collection: @collection, context: @context})

  _edit: (ev) =>
    model = ev.data
    new Customer.ResponseTemplateEditorView({new: false, model: model, context:@context})

  _destroy: (ev) ->
    translations =
      msg: I18n.t('monitoring.user_settings.predefined_templates.noty.msg')
      yes: I18n.t('monitoring.user_settings.predefined_templates.noty.btn_yes')
    model = ev.data

    noty {
      text: translations.msg,
      buttons: [
        {
          addClass: 'btn btn-primary', text: translations.yes, onClick: ($noty) ->
            $noty.close()
            model.destroy({wait: true})
        },
        {
          addClass: 'btn btn-primary', text: 'No', onClick: ($noty) ->
            $noty.close()
        }
      ]
    }

  setLocale: ->   # I don't know why, but if I don't set the locale again, the template list.jst.ejs is not translated
    userLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage
    userLanguage = userLanguage.split('-')[0]
    I18n.locale = if userLanguage in ['en', 'es', 'pt'] then userLanguage else 'en'

  hasWord: (string, substring) ->
    string && string.toUpperCase().indexOf(substring.toUpperCase()) != -1

  _exportAll: =>
    exportJob = new Generic.AsyncJob()
    exportJob.bind('completed', @_onExportComplete)
    exportJob.bind('failed', @_onExportFailure)
    exportJob.start 'account_setting/response_templates/trigger_export_job', {}
    swal
      title: I18n.t('monitoring.user_settings.predefined_templates.export.job_started'),
      type: 'info'

  _onExportComplete: (results) ->
    window.open(results.path, '_blank')

  _onExportFailure: ->
    swal
      title: I18n.t('monitoring.user_settings.predefined_templates.export.error'),
      type: 'error'
